var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.BaseData = {
    id: null,
    options: {
        debug: false,
        entry: {
            json: {
                data: {},
                dataset: '',
                info: {
                    timestamp: 0,
                    variables: []
                },
                payload: false,
                provider: ""

            }
        },
        key_value_delimiter: "-|:-",
        key_value_pair_delimiter: "-/-",
        success: true,
    },

    entry: function () {
        return this.options.entry;
    },
    json: function () {
        return this.options.entry.json;
    },
    data: function () {
        return this.options.entry.json.data;
    },
    parse: function (data) {
        var out_data = {};
        try {
            // Try to decode the data
            out_data = JSON.parse(data);
        } catch (err) {
            console.error(this.class_name + ": " + err);
            out_data = false;
        }
        return out_data;
    },
    has_payload: function () {
        return this.options.entry.json.payload;
    },
    was_successful: function () {
        return this.options.success && this.has_payload();
    },
    stringify: function () {
        return JSON.stringify(this.get_data_obj());
    },
    get_data_key: function () {
        var metadata = this.get_info();
        var vars = this.get_variables_with_units();
        var timestamp = this.get_timestamp_epoch();
        var dataset = this.get_dataset();
        var grid;
        if(this.is_gridded) {
            grid = this.is_gridded();
        }

        var str = [];
        str.push("dataset" + this.options.key_value_delimiter + dataset);
        if (grid !== undefined) {
            str.push("grid" + this.options.key_value_delimiter + grid);
        }
        if (vars !== undefined) {
            str.push("variables" + this.options.key_value_delimiter + JSON.stringify(vars));
        }
        if (timestamp !== undefined) {
            str.push("timestamp" + this.options.key_value_delimiter + timestamp);
        }
        return str.join(this.options.key_value_pair_delimiter);
    },

    get_data_obj: function () {
        return {entry: this.entry(), success: this.was_successful(), data_type: this.data_type};
    },
    get_dataset: function () {
        return this.options.entry.json.dataset;
    },
    get_id: function () {
        if (!this.id) {
            this.id = this.create_unique_id();
        }
        return this.id;
    },
    get_info: function () {
        return this.options.entry.json.info;
    },
    get_timestamp_epoch: function () {
        return this.options.entry.json.info.timestamp;
    },
    get_variables_with_units: function () {
        var vars = this.get_variables();
        var var_obj = [];
        vars.each(function (variable) {
            var_obj.push({parm: variable, units: this.get_variable_units(variable)});
        }.bind(this));
        return var_obj;
    },
    set_url: function (url) {
        var metadata = this.get_info();
        metadata.url = url;
    },
    contains_all_data_variables: function (test_variables) {
        var vars = this.get_variables();
        var result = true;
        var i, variable, units;
        for (i = 0; i < test_variables.length; i++) {
            variable = test_variables[i].parm;
            units = test_variables[i].units;
            if (!vars.contains(variable)) {
                result = false;
            } else if (units && this.get_variable_units(variable) !== units) {
                result = false;
            }
        }
        return result;
    },
    contains_data_variable: function (test_variable, test_units) {
        if (OCS.Utilities.is_string(test_variable)) {
            test_variable = {parm: test_variable};
            if (test_units) {
                test_variable.units = test_units;
            }
        }
        if (this.get_variables().contains(test_variable.parm)) {
            if (test_variable.units && this.get_variable_units(test_variable.parm) !== test_variable.units) {
                return false;
            }
            return true;
        }
        return false;
    },
    get_datetime_obj: function () {
        if (!OCS.Live.OCSDateTime) {
            new OCS.Classes.OCSDateTime();
        }
        return OCS.Live.OCSDateTime;
    },
    parse_datetime: function (inTime) {
        if (OCS.Utilities.isNumber(inTime)) {
            return inTime;
        }
        if (OCS.Utilities.is_string(inTime)) {
            var datetime = OCS.Functions.get_OCSDateTime();
            return datetime.date_long_string_to_epoch(inTime);
        }
    }
    /*
     // Defined by an interface
     get_variables: function () {},
     add_data_variable: function(data_in, variable) {},
     get_data_variable: function (data_var, data_unit) {},
     get_variable_units: function(data_var) {},
     is_gridded: function() {},
     is_valid: function() {}
     */
};